<template>
  <div class="paypos-block">
    <ul v-if="hasMonthlyPrices" class="paypos">
      <li class="paypos__item">
        <div class="paypos__title">
          <img alt="" class="paypos__icon" src="/shop/images/paypos-separate.svg">
          {{ in18['page_split_into_payments'] }}
        </div>
        <div class="paypos__text">{{ in18['page_credit-payments_6m_period'] }}
          {{ monthlyPrices[this.product.id].withoutInterest.monthlyPrice }}
          <span>{{ in18['page_credit-payments_6m_no-overpay'] }}</span>
        </div>
        <div class="fw-500">
          <a :title="in18['link_learn_more_label']" class="link  link--blue" href="#"
             @click="openDialog($event, '#withoutInterest')">
            {{ in18['link_learn_more_label'] }} &#8250;
          </a>
        </div>
      </li>
      <li class="paypos__item">
        <div class="paypos__title">
          <img alt="" class="paypos__icon" src="/shop/images/paypos-loan.svg">
          {{ in18['page_financial_loan'] }}
        </div>
        <div class="paypos__text">
          {{ in18['page_credit-payments_24m_period'] }}
          {{ monthlyPrices[this.product.id].withInterest.monthlyPrice }}
        </div>
        <div class="fw-500">
          <a :title="in18['link_learn_more_label']" class="link  link--blue" href="#"
             @click="openDialog($event, '#withInterest')">
            {{ in18['link_learn_more_label'] }} &#8250;
          </a>
        </div>
      </li>
    </ul><!-- /.paypos -->
  </div>

  <div v-if="hasMonthlyPrices" id="withoutInterest" aria-hidden="true"
       class="modal"
       role="dialog" tabindex="-1">
    <button class="modal__close" data-close-modal type="button">
      <img alt="" src="/shop/images/modal-close.svg">
    </button>

    <div class="modal__header">
      <h2 class="modal__title">{{ in18['dialog_without-interest_title'] }}</h2>
      <div class="modal__text">{{ in18['dialog_without-interest_header-text'] }}</div>
    </div>

    <hr>

    <div class="modal__content  pt-5">
      <h2 class="modal__title   modal__title--sm">{{ in18['dialog_without-interest_payment-list_title'] }}</h2>

      <ul class="modal__list">
        <li>
          <span>{{ in18['dialog_without-interest_payment-list_item-price'] }}</span>
          <span>{{ monthlyPrices[this.product.id].withoutInterest.itemPrice }}</span>
        </li>
        <li>
          <span>{{ in18['dialog_without-interest_payment-list_monthly-payment'] }}</span>
          <span>{{ monthlyPrices[this.product.id].withoutInterest.monthlyPrice }}</span>
        </li>
        <li>
          <span>{{ in18['dialog_without-interest_payment-list_total'] }}</span>
          <span>{{ monthlyPrices[this.product.id].withoutInterest.priceTotal }}</span>
        </li>
        <li>
          <span>{{ in18['dialog_without-interest_payment-list_overpay'] }}</span>
          <span>{{ monthlyPrices[this.product.id].withoutInterest.overpay }}</span>
        </li>
      </ul>
    </div>

    <hr>

    <div class="modal__text">{{ in18['dialog_without-interest_footer-text'] }}</div>
  </div>

  <div v-if="hasMonthlyPrices" id="withInterest" aria-hidden="true" class="modal"
       role="dialog" tabindex="-1">
    <button class="modal__close" data-close-modal type="button">
      <img alt="" src="/shop/images/modal-close.svg">
    </button>

    <div class="modal__header">
      <h2 class="modal__title">{{ in18['dialog_with-interest_title'] }}</h2>
      <div class="modal__text">{{ in18['dialog_with-interest_header-text'] }}</div>
    </div>

    <hr>

    <div class="modal__content  pt-5">
      <h2 class="modal__title   modal__title--sm">{{ in18['dialog_with-interest_payment-list_title'] }}</h2>

      <ul class="modal__list">
        <li>
          <span>{{ in18['dialog_with-interest_payment-list_item-price'] }}</span>
          <span>{{ monthlyPrices[this.product.id].withInterest.itemPrice }}</span>
        </li>
        <li>
          <span>{{ in18['dialog_with-interest_payment-list_monthly-payment'] }}</span>
          <span>{{ monthlyPrices[this.product.id].withInterest.monthlyPrice }}</span>
        </li>
        <li>
          <span>{{ in18['dialog_with-interest_payment-list_total'] }}</span>
          <span>{{ monthlyPrices[this.product.id].withInterest.priceTotal }}</span>
        </li>
        <li>
          <span>{{ in18['dialog_with-interest_payment-list_overpay'] }}</span>
          <span>{{ monthlyPrices[this.product.id].withInterest.overpay }}</span>
        </li>
      </ul>
    </div>

    <hr>

    <div class="modal__text">{{ in18['dialog_with-interest_footer-text'] }}</div>
  </div>
</template>

<script>
export default {
  name:     "ProductCreditPrices",
  props:    {
    product: Object,
    in18:    {
      type: Object,
    }
  },
  computed: {
    hasMonthlyPrices() {
      return this.monthlyPrices[this.product.id] !== undefined && this.monthlyPrices[this.product.id].withInterest !== undefined;
    },
  },
  data() {
    return {
      monthlyPrices: []
    };
  },
  created() {
    this.getCreditPrices();
  },
  methods: {
    getCreditPrices() {
      axios.get(`/api/credit/${this.product.id}/monthly-prices`).then(response => {
        this.monthlyPrices = response.data;
      });
    },
    openDialog(event, selector) {
      event.preventDefault();
      $(selector).modal({
        fadeDuration: 100,
        showClose:    false,
      });
      $("[data-close-modal]").on("click", function (event) {
        event.preventDefault();
        $.modal.close();
      });
    }
  }
}
</script>